import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-email\"><path d=\"M896 192H128c-35.3 0-64 28.7-64 64v512c0 35.3 28.7 64 64 64h768c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64z m-55.35 64L512 534.09 183.35 256h657.3zM128 768V292.99l342.67 289.96c11.97 10.12 26.64 15.19 41.33 15.19 14.67 0 29.36-5.06 41.34-15.2L896 292.99l0.05 475.01H128z\" p-id=\"30122\" fill=\"#1E82CF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol